// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getUserCarsByUsername(_, username) {
            const response = await axios.get(`${MAIN_API}/api/user-car/username`, {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    username
                }
            })
            return response.data
        },
    },
    getters: {
    }
}
